import LibraryAddCheckOutlined from '@mui/icons-material/LibraryAddCheckOutlined';
import { s } from '../../format/schema';
import { defineFieldType, optionSettings, selectedOptionIds } from '../card';
import { CheckboxGroupInput } from './FillInput';
import { FIELD_WIDTH } from '../../format/fieldWidth';

export const checkboxGroup = defineFieldType({
  type: 'checkboxGroup',
  name: 'Checkbox group',
  valueKind: 'options',
  settings: s.strictObject({ ...optionSettings }),
  defaults: {},
  defaultWidth: () => FIELD_WIDTH.FULL,
  value: selectedOptionIds,
  emptyValue: [],
  hasDefaultValue: true,
  validations: ['required', 'range'],
  operators: ['isFilled', 'isEmpty', 'anyOf', 'noneOf', 'allOf'],
  palette: [
    {
      name: 'Checkbox group',
      tooltip: 'Several options, all visible',
      group: 'Choice',
      icon: LibraryAddCheckOutlined,
    },
  ],
  isEmpty: value => value.length === 0,
  quantity: value => value.length,
  comparable: value => value,
  FillInput: CheckboxGroupInput,
  fillLabel: () => 'legend',
});
